<template> 
  <span>
    <div v-b-tooltip.hover :title="$ml.get('notImpact')"  v-if="impact == 'impact-none' || impact == 'impact-undefined'" class='impact impact-low align-self-center mb-1'> 
      <span class='border border-light'>&nbsp;</span>
      <span class='border border-light'>&nbsp;</span>
      <span class='border border-light'>&nbsp;</span>
      <span class='border border-light'>&nbsp;</span> 
      <span class='border border-light'>&nbsp;</span>  
    </div>

    <div v-b-tooltip.hover :title="$ml.get('lowImpact')"  v-if="impact == 'impact-low'" class='impact impact-low align-self-center mb-1'> 
      <span class='color'>&nbsp;</span>
      <span class='color'>&nbsp;</span>
      <span class=''>&nbsp;</span>
      <span class=''>&nbsp;</span>
      <span class=''>&nbsp;</span>
      <span class=''>&nbsp;</span> 
     </div>
     <div v-b-tooltip.hover :title="$ml.get('lowImpact')"  v-if="impact == 'impact-low-billings'" class='impact impact-low-billings align-self-center mb-1'> 
      <span class='color'>&nbsp;</span>
      <span class='color'>&nbsp;</span>
      <span class=''>&nbsp;</span>
      <span class=''>&nbsp;</span>
      <span class=''>&nbsp;</span>
      <span class=''>&nbsp;</span> 
     </div>

    <div v-b-tooltip.hover :title="$ml.get('mediumImpact')" v-if="impact == 'impact-medium'" class='impact impact-medium align-self-center mb-1'> 
      <span class='color'>&nbsp;</span>
      <span class='color'>&nbsp;</span>
      <span class='color'>&nbsp;</span>
      <span class=''>&nbsp;</span>
      <span class=''>&nbsp;</span>
      <span class=''>&nbsp;</span> 
    </div>
    <div v-b-tooltip.hover :title="$ml.get('mediumImpact')" v-if="impact == 'impact-medium-billings'" class='impact impact-medium-billings align-self-center mb-1'> 
      <span class='color'>&nbsp;</span>
      <span class='color'>&nbsp;</span>
      <span class='color'>&nbsp;</span>
      <span class=''>&nbsp;</span>
      <span class=''>&nbsp;</span>
      <span class=''>&nbsp;</span> 
    </div>

    <div v-b-tooltip.hover :title="$ml.get('highImpact')" v-if="impact == 'impact-high'" class='impact impact-high align-self-center mb-1'> 
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class=''>&nbsp;</span> 
    </div>
    <div v-b-tooltip.hover :title="$ml.get('highImpact')" v-if="impact == 'impact-high-billings'" class='impact impact-high-billings align-self-center mb-1'> 
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class=''>&nbsp;</span> 
    </div>

    <div v-b-tooltip.hover :title="$ml.get('criticalImpact')" v-if="impact == 'impact-critical'" class='impact impact-critical align-self-center mb-1'> 
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span> 
    </div>
    <div v-b-tooltip.hover :title="$ml.get('criticalImpact')" v-if="impact == 'impact-critical-billings'" class='impact impact-critical-billings align-self-center mb-1'> 
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span>
        <span class='color'>&nbsp;</span> 
    </div>
  </span>
 

</template>
<script> 

export default {
  name: "impact", 
  props: {
    impact: {
      type: String,
      required: true,
      default: null,
    },
  },
  components: {},
  data() {
    return { 
    };
  },
  computed: {},
  mounted() { 
  },
  methods: { 
  },
};
</script>
